var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie',{attrs:{"options":_vm.options,"height":_vm.height,"width":_vm.width},on:{"animCreated":_vm.handleAnimation}})
}
var staticRenderFns = []

export { render, staticRenderFns }